import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import SlowMotionVideoOutlinedIcon from '@mui/icons-material/SlowMotionVideoOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useRef, useEffect } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState } from "react";
import AddLinkRoundedIcon from '@mui/icons-material/AddLinkRounded';
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import api from '../../../../../../../Apis';
import Swal from 'sweetalert2'
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { Controller, useForm } from "react-hook-form";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import { FormControlLabel, Paper, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import MarkUnreadChatAltRoundedIcon from '@mui/icons-material/MarkUnreadChatAltRounded';
import Radio from '@mui/material/Radio';
import { useDispatch } from 'react-redux';
import { getMessSample } from '../../../../../../../Store/Actions/GetMessSample';
import DialogBlock from './DialogBlock';

function ManageAttachment(props) {
    const [state, setState] = useState(
        {
            open: false,
            dialog_link: false,
            dialog_mess: false,
            dialog_mess_coupon: false,
            dialog_block: false,
            attachments: [],
            errors: [],
            image_selected: [],
            input_link: false,
            new_image: []
        }  
    );
    const inputFile = useRef(null);
    const buttonSubmit = useRef(null);
    const {register, handleSubmit, reset, control, getValues, setValue} = useForm();
    const dispatch = useDispatch();
    const selectFile = (e) => {
        inputFile.current.click();
    }
    const onChangeFile = (e) => {
        const file = e.target.files[0];
        if (file.size/1024 > 25600) {
            Swal.fire({
                title: "Yêu cầu file tối đa 25MB",
                icon: 'warning',
                confirmButtonText: 'Thoát'
            })
        } else {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('fanpage_id', props.fanpage_id);
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + props.cookie
                },
                body: formData
            };
            fetch(api.upload_attachment, requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.success == true) {
                        setState({...state, new_image: [result.datas], attachments: [result.datas, ...state.attachments]});
                    } else if (result.success == false && result.type == 'validate') {
                        if (result.errors.length > 0) {
                            var string_error = '';
                            result.errors.map((value, key) => {
                                string_error = string_error + '<p>' + value + '</p>';
                            })
                            Swal.fire({
                                title: string_error,
                                icon: 'warning',
                                confirmButtonText: 'Thoát'
                            })
                        }
                    } else if (result.success == false && result.type == 'error') {
                        Swal.fire({
                            title: result.message,
                            icon: 'error',
                            confirmButtonText: 'Thoát'
                        })
                    }
                }
            )
        }
        // props.onSendAttchment(form);
    }

    const handleClickOpen = () => {
        reset();
        setState({...state, open: true});
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.cookie
            },
            body: JSON.stringify({
                fanpage_id: props.fanpage_id,
            })
        };
        fetch(api.get_attachment, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    setState({
                        ...state,
                        attachments: result.datas,
                        open: true
                    })
                }
            }
        )
    }

    const handleClose = () => {
        setState({...state, open: false});
    }

    // const handleSubmitImage = () => {
    //     buttonSubmit.current.click();
    // }

    const handleChangeKeySearch = (e) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.cookie
            },
            body: JSON.stringify({
                fanpage_id: props.fanpage_id,
                name_file: e.target.value
            })
        };
        fetch(api.search_name_file, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success == true) {
                    setState({...state, attachments: result.datas});
                } else {
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }
        )
    }

    const onSendImage = (data) => {
        if (data.links.length > 0) {
            const attachments = [];
            data.links.map((value, key) => {
                attachments.push({
                    'mime_type': "image/jpeg",
                    'file_url': null,
                    'video_data': null,
                    'image_data': value
                })
            })
            const action = getMessSample({
                message: '',
                attachments: attachments,
                rand: Math.random()
            });
            dispatch(action);
            setState({
                ...state,
                open: false
            })
        } else {
            Swal.fire({
                title: 'Vui lòng chọn ảnh',
                icon: 'warning',
                timer: 1500
            });
        }
        // if (data.links == false || data.links.length == 0) {
        //     Swal.fire({
        //         title: 'Cần chọn ảnh',
        //         icon: 'warning',
        //         confirmButtonText: 'Thoát'
        //     })
        // } else {
        //     props.onSendAttchment(data.links);
        //     setState({...state, open: false});
        // }
    }

    const onUploadImageByLink = (data) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.cookie
            },
            body: JSON.stringify({
                fanpage_id: props.fanpage_id,
                url: data.url
            })
        };
        fetch(api.upload_url, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success == true) {
                    setState({...state,
                                dialog_link: false,
                                attachments: [
                                    {link: data.url, name: data.url},
                                    ...state.attachments
                                ]
                            });
                    Swal.fire({
                        title: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }
        )
        reset();
    }
    
    const deleteImage = (id, index) => {
        if (window.confirm('Bạn có chắc chắn xóa ảnh này không?')) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + props.cookie
                },
                body: JSON.stringify({
                    id: id,
                    fanpage_id: props.fanpage_id
                })
            };
            fetch(api.delete_file, requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.success) {
                        const copy_attachments = [...state.attachments];
                        copy_attachments.splice(index, 1);
                        setState({...state,
                                    attachments: copy_attachments
                                });
                        Swal.fire({
                            title: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        })
                    } else {
                        Swal.fire({
                            title: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }
                }
            )
        }

        return false;
    }

    const selectedImage = (e) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            setState({...state, image_selected: [...state.image_selected, e.target.value]});
        } else {
            // const index = array.indexOf(item);
        }    
    }
    const pickMessSample = (data) => {
        var content = data.content;
        const array_replace = [{key: "{name}", value: props.name_sender}, {key: "{page_name}", value: props.fanpage_name}];
        for (var i = 0; i < array_replace.length; i++) {
            var content_new = content.replaceAll(array_replace[i].key, array_replace[i].value);
            content = content_new;
        }
        const action = getMessSample({
            message: content_new,
            attachments: data.images,
            rand: Math.random()
        });
        dispatch(action);
        setState({...state, dialog_mess: false});
        //props.getMessSample(content_new);
    }

    const sendCouponMessage = (data) => {
        var content = data.content;
        const array_replace = [{key: "{name}", value: props.name_sender}, {key: "{page_name}", value: props.fanpage_name}];
        for (var i = 0; i < array_replace.length; i++) {
            var content_new = content.replaceAll(array_replace[i].key, array_replace[i].value);
            content = content_new;
        }
        const action = getMessSample({
            message: content_new,
            attachments: [],
            rand: Math.random()
        });
        dispatch(action);
        setState({...state, dialog_mess_coupon: false});
    }

    return (
        <div className="attachment">
            <Dialog open={state.dialog_link} fullWidth="true" maxWidth='sm' onClose={() => {setState({...state, dialog_link: false})}}>
                <DialogTitle>Nhập link ảnh</DialogTitle>
                <form onSubmit={handleSubmit(onUploadImageByLink)}>
                    <DialogContent sx={{paddingTop: '0px'}}>
                        <p className='m-b-0 m-t-0'>
                            Tải ảnh lên Fanpage và copy link ảnh
                        </p>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Đường dẫn ảnh của bạn"
                            type="text"
                            fullWidth
                            variant="outlined"
                            {...register('url')}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {setState({...state, dialog_link: false})}}>Đóng</Button>
                        <Button type="submit">Xác nhận</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog open={state.dialog_mess} fullWidth="true" maxWidth='sm' onClose={() => {setState({...state, dialog_mess: false})}}>
                <DialogTitle>Chọn tin nhắn mẫu</DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Từ khóa</TableCell>
                                        <TableCell>Nội dung</TableCell>
                                        <TableCell>Hành động</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        props.mess_samples.map((row, key) => (
                                            <TableRow
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row">
                                                    {row.keyword}
                                                </TableCell>
                                                <TableCell>
                                                    {row.content}
                                                </TableCell>
                                                <TableCell>
                                                    <Button onClick={() => pickMessSample(row)} sx={{marginRight: '5px', textTransform: 'none'}} variant="contained" color="primary">
                                                        Dùng
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
            </Dialog>
            <Dialog open={state.dialog_mess_coupon} fullWidth="true" maxWidth='sm' onClose={() => {setState({...state, dialog_mess_coupon: false})}}>
                <DialogTitle>Chọn tin nhắn khuyến mại</DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tên</TableCell>
                                        <TableCell>Nội dung</TableCell>
                                        <TableCell>Hành động</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        props.coupon_messages.map((value, index) => {
                                            return (
                                                <TableRow>
                                                    <TableCell>
                                                        {value.name}
                                                    </TableCell>
                                                    <TableCell>
                                                        {value.content}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button onClick={() => sendCouponMessage(value)} variant='contained' className='text-transform'>
                                                            Dùng
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
            </Dialog>
            
            <Dialog
                fullWidth="true"
                maxWidth='lg'
                open={state.open}
                onClose={handleClose}
            >
                <DialogTitle sx={{display: "flex", justifyContent: "space-between"}}>
                    Ảnh của shop
                    <Button startIcon={<CloseOutlinedIcon />} variant="contained" color="warning" onClick={handleClose}>
                        Đóng
                    </Button>
                </DialogTitle>
                <DialogContent sx={{overflowY: "unset"}}>
                    <Button onClick={selectFile} sx={{
                        marginRight: '20px'
                        }}
                        variant="outlined" color="primary" startIcon={<UploadRoundedIcon />}>
                        Tải ảnh lên
                    </Button>
                    <Button sx={{
                        marginRight: '20px'
                        }} onClick={() => {setState({...state, input_link: true, dialog_link: true})}} variant="outlined" color="success" startIcon={<AddLinkRoundedIcon />}>
                        Từ URL
                    </Button>
                    <TextField size="small" id="outlined-basic" onChange={handleChangeKeySearch} label="Tìm kiếm tên ảnh" variant="outlined"></TextField>
                </DialogContent>
                <DialogContent>
                    <form onSubmit={handleSubmit(onSendImage)}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                {
                                    state.attachments.map((value, key) => {
                                        return (
                                            <Grid item xs={2} sx={{position: 'relative'}}>
                                                <input {...register('links')} style={{position: 'absolute', right: '0px', borderRadius: 'unset'}} type="checkbox" name="links" value={value.link}></input>
                                                {/* <Radio {...register('links')} name="links" value={value.link} size="medium" sx={{position: 'absolute', right: '0px', borderRadius: 'unset'}}></Radio> */}
                                                <div className='block-image'>
                                                    <img className='lib-image' src={value.link}></img>
                                                    <p className='name'>
                                                        {value.name}
                                                    </p>
                                                    <p className='m-b-0'>
                                                        <Button onClick={() => deleteImage(value.id, key) } color='error' startIcon={<DeleteRoundedIcon/>} size='small' variant="contained">Xóa</Button>
                                                    </p>
                                                </div>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Button type="submit" sx={{margin: "20px 0px 0px 0px", width: '100%'}} startIcon={<SendRoundedIcon />} variant="contained" color="primary">
                                        Xác nhận
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                        {/* <button type='submit'  ref={buttonSubmit} style={{display: 'none'}}>Submit</button> */}
                    </form>
                </DialogContent>
                    
            </Dialog>
            <input ref={inputFile} onChange={onChangeFile} type="file" className='file'/>
            <div>
                <Tooltip arrow onClick={handleClickOpen} title="Gửi ảnh" placement="top">
                    <ImageOutlinedIcon></ImageOutlinedIcon>
                </Tooltip>
            </div>
            
            {/* <Tooltip title="Gửi video" placement="top">
                <SlowMotionVideoOutlinedIcon></SlowMotionVideoOutlinedIcon>
            </Tooltip>
            <Tooltip title="Gửi block" placement="top">
                <WidgetsOutlinedIcon></WidgetsOutlinedIcon>
            </Tooltip> */}
            <div>
                <Tooltip arrow onClick={() => {setState({...state, dialog_mess: true})}} title="Mẫu trả lời nhanh" placement="top">
                    <ArticleOutlinedIcon></ArticleOutlinedIcon>
                </Tooltip>
            </div>
            <div>
                <Tooltip arrow onClick={() => {setState({...state, dialog_mess_coupon: true})}} title="Mẫu khuyến mại" placement="top">
                    <MarkUnreadChatAltRoundedIcon/>
                </Tooltip>
            </div>
            <DialogBlock
                cookie={props.cookie}
                receive_id={props.receive_id}
                fanpage_id={props.fanpage_id}
            />
        </div>
    )
}

export default ManageAttachment;